export default "__VITE_PUBLIC_ASSET__5df08dfc__"